"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ALL_THEMES", {
  enumerable: true,
  get: function get() {
    return _themes.ALL_THEMES;
  }
});
Object.defineProperty(exports, "MOBILE_THEMES", {
  enumerable: true,
  get: function get() {
    return _themes.MOBILE_THEMES;
  }
});
Object.defineProperty(exports, "PROD_THEMES", {
  enumerable: true,
  get: function get() {
    return _themes.PROD_THEMES;
  }
});
Object.defineProperty(exports, "STANDARD_THEMES", {
  enumerable: true,
  get: function get() {
    return _themes.default;
  }
});
Object.defineProperty(exports, "getDefaultTheme", {
  enumerable: true,
  get: function get() {
    return _getDefaultTheme.default;
  }
});
Object.defineProperty(exports, "getSupportedThemes", {
  enumerable: true,
  get: function get() {
    return _getSupportedThemes.default;
  }
});
Object.defineProperty(exports, "isFiori", {
  enumerable: true,
  get: function get() {
    return _isFiori.default;
  }
});
Object.defineProperty(exports, "isHorizon", {
  enumerable: true,
  get: function get() {
    return _isHorizon.default;
  }
});
Object.defineProperty(exports, "isQuartz", {
  enumerable: true,
  get: function get() {
    return _isQuartz.default;
  }
});
Object.defineProperty(exports, "isThemeSupported", {
  enumerable: true,
  get: function get() {
    return _isThemeSupported.default;
  }
});
Object.defineProperty(exports, "parseThemeName", {
  enumerable: true,
  get: function get() {
    return _parseThemeName.default;
  }
});
var _isFiori = _interopRequireDefault(require("./utils/isFiori"));
var _isHorizon = _interopRequireDefault(require("./utils/isHorizon"));
var _isQuartz = _interopRequireDefault(require("./utils/isQuartz"));
var _getDefaultTheme = _interopRequireDefault(require("./utils/getDefaultTheme"));
var _parseThemeName = _interopRequireDefault(require("./utils/parseThemeName"));
var _getSupportedThemes = _interopRequireDefault(require("./utils/getSupportedThemes"));
var _isThemeSupported = _interopRequireDefault(require("./utils/isThemeSupported"));
var _themes = _interopRequireWildcard(require("./themes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }